import React from "react";
// import "./App.css";
import "./style/main.css";
import "./components/Layout/Layout.css"
// import "./components/Sidebar/Sidebar.css"
// import "./components/Dropdown/Dropdown.css"
// import "./components/AddAdminModal/AddAdminModal.css"

import Layout from "./components/Layout/Layout";
import { _axios } from "./utils/axios";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { cookieUtils } from "./utils/cookieUtils";

const App = () => {
  const navigate = useNavigate()
  const qc = useQueryClient();

  const clearAllCookies = () => {
    // Clear all known cookies
    cookieUtils.removeSecureCookie('userDetails');
    cookieUtils.removeSecureCookie('token');
    cookieUtils.removeSecureCookie('subRole');
    // Add any other cookies that need to be cleared
  };
  
  _axios.interceptors.response.use(
    (response: any) => {
      console.log('interceptors response', response)
      // if(response?.data?.message === 'access denied! unautorized user' || response?.data?.message === "Invalid Token"){
      //   navigate("/onboarding/login");
      // }
      if (response?.data?.success === 0 && response?.data?.message === 'Access Denied!') {
        console.log('interceptors inside', response)
        qc.clear();
        localStorage.clear();
        clearAllCookies();
        navigate("/onboarding/login");
      }
      return response;
    },
    (err) => Promise.reject(err)
  );
  return (
    <Layout />
  )
}

export default App;
